import * as editableElements from './editable-elements';

export default {
  editableElements,
};
